import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrLogoutComponent } from './kn-br-logout.component';
import { Routes } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';


const staticRoutes: Routes = [{
  path: '/logout',
  component: KnBrLogoutComponent
}];

@NgModule({
    imports: [CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrLogoutComponent: {
                    component: KnBrLogoutComponent,
                },
            },
        } as CmsConfig), KnBrLogoutComponent,],
    exports: [KnBrLogoutComponent]
})

export class KnBrLogoutModule { }
